import React from 'react'

export default function Modaljadwalterbokinguser({ data }) {

    return (
        <div>
            <div className='text-center'>
                <img src="./img/modal1.png" className="img-fluid" style={{ height: '150px' }}></img>
                <h5 className='fw-bold' style={{ color: '#2b2e5a' }}><i class="fa-solid fa-circle-exclamation" style={{ color: '#2b2e5a' }}></i> Opps....</h5>
                <div className='text-secondary'>
                    Jadwal rank team ini sudah anda booking sebelumnya, proses booking anda {data.status_pembayaran == 200 ? <>sudah <b>Disetujui</b></> : <>belum <b>Disetujui</b></>}

                </div>
            </div>
        </div>
    )
}
